import axios from "services/axios";
import {useMutation, useQueryClient} from "react-query";

export function useAddPrice(options = {}) {
	const queryClient = useQueryClient();

	return useMutation(values => axios.post("/doctor-prices", values).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries("doctor-prices");
			queryClient.removeQueries("doctor-prices");
		},
	});
}
export function useEditPrice(options = {}) {
	const queryClient = useQueryClient();

	return useMutation(formData => axios.post(`/doctor-prices/${formData.id}`, formData).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries("doctor-prices");
			queryClient.removeQueries("doctor-prices");
		},
	});
}

export function useDeletePrice(options = {}) {
	const queryClient = useQueryClient();

	return useMutation(formData => axios.post("/doctor-prices/delete", formData).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries("doctor-prices");
			queryClient.removeQueries("doctor-prices");
		},
	});
}
